import { useQueryClient } from "@tanstack/react-query";
import { emptyListFunc } from "components/MainSectionTemplate/emptySubmitChangeFunc";
import React from "react";
import { invalidateTimetableCache } from "utilities/api/timetableQuery";
import { DetailSidePanel } from "../DetailSidePanel";
import { useOpenSidePanel } from "../SidePanel";
import { SidePanelDeleteEntryButton } from "../SidePanelDeleteEntryButton";
import { TimetableSidePanelDetails } from "./TimetableSidePanelDetails";

export const useOpenTimetableSidePanel = () => {
  const openSidePanel = useOpenSidePanel();
  const queryClient = useQueryClient();

  const openTimetableSidePanel = React.useCallback((entry: server.dto.TimetableEntry, canModify: boolean) => {
    openSidePanel(<DetailSidePanel
      apiCall={() => emptyListFunc()}
      apiKey="timetableEntry"
      entityId={entry.timetableEntryId}
      title={RESX.Timetable.TimetableItem}
      footerContent={canModify && <SidePanelDeleteEntryButton
        apiCall={() => window.CoreApi.Timetable.DeleteEntry({ timetableEntryId: entry.timetableEntryId }, { toastOnError: true })}
        onSuccess={() => { invalidateTimetableCache(queryClient); }}
      />}
      skipSidePanelBase
    >
      {() => <TimetableSidePanelDetails entry={entry} canModify={canModify} />}
    </DetailSidePanel>, `timetableEntry-side-${entry.timetableEntryId}`, "medium");
  }, [openSidePanel, queryClient]);

  return openTimetableSidePanel;
};
